// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.panel[data-v-25aefcfc] {\n  margin-top: 3px;\n}\n.show_entries[data-v-25aefcfc] {\n  margin-top: 20px;\n}\n.Excel[data-v-25aefcfc] {\n  margin: auto 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
